import React from 'react';
import BEM from '../bem';
import AskTigerSparkle from '../images/ask-tiger-sparkle.svg';
import { actions, useAppDispatch, useAppSelector } from 'redux-stores';

const { setTigerAgentPaneOpen } = actions;

const classes = BEM.with('TigerAgentButton');

type TigerAgentButtonProps = {
  placement?: 'header' | 'sidebar';
};

export default function TigerAgentButton({ placement = 'header' }: TigerAgentButtonProps) {
  const dispatch = useAppDispatch();
  const tigerAgentPaneOpen = useAppSelector((state) => state.ui.tigerAgentPaneOpen);

  return (
    <button
      className={classes({ placement })}
      aria-label="Ask Tiger"
      data-test-id="tiger-agent-button"
      onClick={() => dispatch(setTigerAgentPaneOpen(!tigerAgentPaneOpen))}
      title="Ask Tiger"
      type="button"
    >
      <span className={classes('icon-stack')}>
        <img src={AskTigerSparkle} alt="" aria-hidden className={classes('icon')} />
      </span>
      <span className={classes('label')}>Ask Tiger</span>
    </button>
  );
}
